import { h as hasLocalStorage, i as attemptGetLocalStorage, j as attemptWriteLocalStorage } from "./index-26c1728a.js";
/*!
 * Kantar FocalMeter integration for Snowplow v3.23.0 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */
var _trackers = {};
var _configurations = {};
function FocalMeterPlugin() {
  var LOG;
  var lastUserId;
  var trackerId;
  return {
    activateBrowserPlugin: function(tracker) {
      trackerId = tracker.id;
      _trackers[tracker.id] = tracker;
    },
    logger: function(logger) {
      LOG = logger;
    },
    afterTrack: function(payload) {
      if (!_configurations[trackerId]) {
        LOG.error("FocalMeter integration not enabled");
        return;
      }
      var newUserId = payload["duid"];
      var _a = _configurations[trackerId], kantarEndpoint = _a.kantarEndpoint, useLocalStorage = _a.useLocalStorage, processUserId = _a.processUserId;
      if (!lastUserId && useLocalStorage && hasLocalStorage()) {
        var key = getLocalStorageKey(trackerId);
        lastUserId = attemptGetLocalStorage(key);
      }
      if (newUserId && newUserId != lastUserId) {
        lastUserId = newUserId;
        var processedUserId = processUserId !== void 0 ? processUserId(newUserId) : newUserId;
        sendRequest(kantarEndpoint, processedUserId, LOG, function() {
          if (useLocalStorage && hasLocalStorage()) {
            var key2 = getLocalStorageKey(trackerId);
            attemptWriteLocalStorage(key2, newUserId);
          }
        });
      }
    }
  };
}
function enableFocalMeterIntegration(configuration, trackers) {
  if (trackers === void 0) {
    trackers = Object.keys(_trackers);
  }
  for (var _i = 0, trackers_1 = trackers; _i < trackers_1.length; _i++) {
    var id = trackers_1[_i];
    if (_trackers[id]) {
      _configurations[id] = configuration;
    }
  }
}
function getLocalStorageKey(trackerId) {
  return "sp-fclmtr-".concat(trackerId);
}
function sendRequest(url, userId, LOG, successCallback) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", getKantarURL(url, userId));
  xhr.timeout = 5e3;
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status >= 200) {
      if (xhr.status < 300) {
        successCallback();
        LOG.debug("ID sent to Kantar: ".concat(userId));
      } else {
        LOG.error("Kantar request failed: ".concat(xhr.status, ": ").concat(xhr.statusText));
      }
    }
  };
  xhr.send();
}
function getKantarURL(url, userId) {
  var query = {
    vendor: "snowplow",
    cs_fpid: userId,
    c12: "not_set"
  };
  return url + "?" + Object.keys(query).map(function(key) {
    return key + "=" + query[key];
  }).join("&");
}
export {
  FocalMeterPlugin,
  enableFocalMeterIntegration
};
